import dayjs, { Dayjs } from 'dayjs';
import type { Report } from '@/data/corporate-university/course/report/types';

dayjs.locale('pt-br');

export const filterByCourse = (
  report: Report[],
  courseFilter: string
): Report[] => {
  if (!courseFilter) return report;
  return report.filter((course) =>
    course.course.name.toLowerCase().includes(courseFilter.toLowerCase())
  );
};

export const filterByColaborador = (
  report: Report[],
  colaboradorFilter: string
): Report[] => {
  if (!colaboradorFilter) return report;
  return report.filter((course) =>
    course?.user?.name?.toLowerCase().includes(colaboradorFilter.toLowerCase())
  );
};

export const filterByDateRange = (
  report: Report[],
  dateFrom: Dayjs | null,
  dateTo: Dayjs | null
): Report[] => {
  if (!dateFrom || !dateTo) return report;
  return report.filter((course) => {
    if (!course?.finished_time) return false;
    const courseEndDate = dayjs(course.finished_time).startOf('day');
    const from = dateFrom.startOf('day');
    const to = dateTo.endOf('day');
    return (
      (courseEndDate.isAfter(from) || courseEndDate.isSame(from)) &&
      (courseEndDate.isBefore(to) || courseEndDate.isSame(to))
    );
  });
};
